module.exports = __webpack_public_path__ + "static/logo-home-31af480a7a8983e3e22a94b7b07b4440.png";